import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["title", "description", "issues", "confirmButton", "cancelButton"]

  open(event) {
    const { impact, resolve } = event.detail
    this.resolve = resolve
    this.titleTarget.textContent = impact.title
    this.descriptionTarget.textContent = impact.description
    this.confirmButtonTarget.textContent = impact.confirm_label
    this.confirmButtonTarget.hidden = !impact.confirmable
    this.confirmButtonTarget.dataset.confirmable = impact.confirmable
    this.cancelButtonTarget.textContent = impact.cancel_label
    this.issuesTarget.replaceChildren(...impact.issues.map(({ message }) => this.issue(message)))
    this.element.showModal()
  }

  confirm() {
    if (this.confirmButtonTarget.hidden) return

    this.finish(true)
  }

  cancel(event) {
    event?.preventDefault()
    this.finish(false)
  }

  backdrop(event) {
    if (event.target === this.element) this.cancel(event)
  }

  keep(event) {
    event.stopPropagation()
  }

  closed() {
    if (this.resolve) this.finish(false)
  }

  finish(answer) {
    const resolve = this.resolve
    this.resolve = null
    if (this.element.open) this.element.close()
    resolve?.(answer)
  }

  issue(message) {
    const item = document.createElement("li")
    item.className = "rounded-xl border border-border bg-card px-4 py-3 text-sm"
    item.textContent = message
    return item
  }
}
